module.exports = __webpack_public_path__ + "static/color-wheel-0ee6067e2c976cae611412f721c62360.png";